/**
 * Normalizes common backend list shapes into a plain array.
 * Handles: raw array, { data: [] }, { items: [] }, nested { data: { data: [] } }.
 */
export function normalizeApiListResponse<T = unknown>(response: unknown): T[] {
  if (Array.isArray(response)) {
    return response as T[];
  }
  if (!response || typeof response !== 'object') {
    return [];
  }
  const obj = response as Record<string, unknown>;
  const data = obj['data'];
  if (Array.isArray(data)) {
    return data as T[];
  }
  if (data && typeof data === 'object') {
    const nested = (data as Record<string, unknown>)['data'];
    if (Array.isArray(nested)) {
      return nested as T[];
    }
  }
  if (Array.isArray(obj['items'])) {
    return obj['items'] as T[];
  }
  if (Array.isArray(obj['results'])) {
    return obj['results'] as T[];
  }
  return [];
}

/** Active bank: bank_status 1 or missing (getActiveBanks already filters server-side). */
export function isActiveBankRecord(bank: { bank_status?: unknown }): boolean {
  if (bank.bank_status == null || bank.bank_status === '') {
    return true;
  }
  return Number(bank.bank_status) === 1;
}

export function filterActiveBanks<T extends { bank_status?: unknown }>(banks: T[]): T[] {
  return banks.filter(isActiveBankRecord);
}
